import { render } from "./NotaSpesaNode.vue?vue&type=template&id=68f400a9&scoped=true"
import script from "./NotaSpesaNode.vue?vue&type=script&lang=js"
export * from "./NotaSpesaNode.vue?vue&type=script&lang=js"

import "./NotaSpesaNode.vue?vue&type=style&index=0&id=68f400a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f400a9"]])

export default __exports__